import React from "react";
import { motion } from "framer-motion";

export default function IntegrationsAndRoadmapSection() {
  const roadmap = [
    {
      title: "AI Attendance Anomaly Detection",
      desc:
        "Automatically detects irregular punches, GPS mismatches, abnormal shift timings, rapid punch patterns and possible spoof attempts — ensuring accurate and trusted attendance validation for HR.",
    },
    {
      title: "Advanced Workforce Analytics",
      desc:
        "Deep insights for workforce patterns including headcount trends, overtime behavior, leave heatmaps, productivity indicators, cost forecasts and department-wise performance metrics.",
    },
    {
      title: "Voice-Based HR Assistant",
      desc:
        "Employees can use natural voice commands to perform actions instantly — apply leave, view punch history, check balances, download payslips and generate summaries hands-free.",
    },
    {
      title: "Automated Document Generator",
      desc:
        "Auto-generates HR documents like offer letters, appraisal letters, confirmation letters, salary structures and experience letters with department-based templates.",
    },
    {
      title: "Predictive Leave Planning",
      desc:
        "AI recommends ideal leave dates by analyzing workload patterns, deadlines, team availability, holidays and historical trends to reduce workflow disruptions.",
    },
  ];

  return (
    <section
      className="py-24 bg-white border-t border-gray-200"
      style={{ fontFamily: "Poppins, Roboto, sans-serif" }}
    >
      <div className="max-w-6xl mx-auto px-6">

        {/* ================================================= */}
        {/* HEADER */}
        {/* ================================================= */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-semibold text-gray-900 text-center"
        >
          Roadmap & Upcoming Enhancements
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.15, duration: 0.6 }}
          viewport={{ once: true }}
          className="text-gray-600 max-w-2xl text-center mx-auto mt-3 text-base leading-relaxed"
          style={{ fontFamily: "Roboto, sans-serif" }}
        >
          A future-ready HR system continuously evolving with intelligence,
          automation and real operational enhancements.
        </motion.p>

        {/* ================================================= */}
        {/* ROADMAP LIST */}
        {/* ================================================= */}
        <div className="mt-16 space-y-10 relative">

          {/* Vertical Line */}
          <div className="absolute left-6 top-0 bottom-0 w-[2px] bg-gray-300"></div>

          {roadmap.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.12 }}
              viewport={{ once: true }}
              className="pl-14"
            >
              {/* Dot */}
              <div className="absolute left-[14px] mt-1 w-4 h-4 bg-gray-900 rounded-full"></div>

              {/* Title */}
              <h3 className="text-lg font-semibold text-gray-900">
                {item.title}
              </h3>

              {/* Description */}
              <p
                className="text-gray-600 text-sm leading-relaxed mt-1.5"
                style={{ fontFamily: "Roboto, sans-serif" }}
              >
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
